import { ClientReturnsRelatedArticlesQuery } from './queries/client-returns';
import { SanityRelatedArticlesSection } from 'types/sanity/education-center';
import { useQuery } from 'villus';
import { villusClient } from '@utils/villus';

interface SanityClientReturnsRelatedArticlesResponse {
	allClientReturnsLandingPage: Array<{
		investorUpdatesSection: SanityRelatedArticlesSection;
	}>;
}

export async function getClientReturnsRelatedArticles(): Promise<SanityRelatedArticlesSection | null> {
	const { data } = await useQuery<SanityClientReturnsRelatedArticlesResponse>({
		client: villusClient,
		query: ClientReturnsRelatedArticlesQuery,
		tags: ['client_returns_related_articles']
	}).execute();

	const clientReturnsMarketingPage = data?.allClientReturnsLandingPage[0].investorUpdatesSection;
	return clientReturnsMarketingPage ?? null;
}
